import {
  Box,
  HStack,
  Icon,
  IconButton,
  Image,
  SimpleGrid,
  Text,
  VStack,
  Link as ChakraLink,
} from "@chakra-ui/react";
import React from "react";
import Container from "./Container";
import sosmenLinks from "../const/sosmedLinksDummy";
import FooterPopularCourse from "./list/FooterPopularCourse";

export default function Footer() {
  const today = new Date();

  return (
    <VStack w={"100%"} bg={"p.900"} pt={10} pb={6} mt={"auto"}>
      <Container>
        <SimpleGrid columns={[1, 2]} gap={20} mb={20}>
          <Box>
            <HStack gap={1} flexShrink={0} mb={4}>
              <Image src="/images/logoTransparent.png" h={"50px"} />
              <Box color={"white"}>
                <Text fontWeight={800} lineHeight={1.4}>
                  KUBU
                </Text>
                <Text fontWeight={800} lineHeight={1.4}>
                  COURSE
                </Text>
              </Box>
            </HStack>

            <Text color={"white"} mb={4}>
              Tidak perlu khawatir tentang jadwal yang ketat. Dengan kursus
              online, Anda dapat belajar kapan saja, di mana saja. Fleksibilitas
              ini memungkinkan Anda mengatasi hambatan waktu dan tempat, memberi
              Anda kendali penuh atas pendidikan Anda.
            </Text>

            <HStack>
              {sosmenLinks.map((sosmed, i) => (
                <IconButton
                  key={i}
                  aria-label={`${sosmed.name}Link`}
                  icon={<Icon as={sosmed.icon} fontSize={24} />}
                  className="btn"
                  color={"white"}
                />
              ))}
            </HStack>
          </Box>

          <Box>
            <Text fontSize={20} fontWeight={600} color={"white"} mb={4}>
              Kursus Populer
            </Text>

            <FooterPopularCourse />
          </Box>
        </SimpleGrid>

        <HStack color={"white"} justify={"space-between"}>
          <Text>Copyright © {today.getFullYear()} Kubu.id Online Course</Text>

          <Text
            as={ChakraLink}
            isExternal
            href={"https://kubu.id/privacy-policy"}
          >
            Privacy Terms & Conditions
          </Text>
        </HStack>
      </Container>
    </VStack>
  );
}
